import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  FeatureCatalogResponse,
  MyFeatureAccessResponse,
} from '../models/feature-access.model';

@Injectable({ providedIn: 'root' })
export class FeatureAccessApiService {
  private readonly http = inject(HttpClient);

  getMe(): Observable<MyFeatureAccessResponse> {
    return this.http.get<MyFeatureAccessResponse>('/api/feature-access/me');
  }

  getCatalog(): Observable<FeatureCatalogResponse> {
    return this.http.get<FeatureCatalogResponse>('/api/feature-access/catalog');
  }

  addEmail(key: string, email: string): Observable<void> {
    return this.http.post<void>(
      `/api/feature-access/${encodeURIComponent(key)}/whitelist`,
      { email },
    );
  }

  removeEmail(key: string, email: string): Observable<void> {
    return this.http.delete<void>(
      `/api/feature-access/${encodeURIComponent(key)}/whitelist/${encodeURIComponent(email)}`,
    );
  }
}
